import { useCallback, useEffect, useState } from "react";
import { apiUtils } from "../../../utils/apiUtils";

export default function useRepGuardClients() {
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [loadingClients, setLoadingClients] = useState(true);
  const [clientError, setClientError] = useState("");

  const loadClients = useCallback(async () => {
    try {
      setLoadingClients(true);
      setClientError("");
      const response = await apiUtils.get("/api/clients", {
        params: {
          limit: 200,
        },
      });

      const list = response.data?.data?.clients || [];
      setClients(list);
      setSelectedClientId((current) => current || list[0]?._id || "");
    } catch (error) {
      setClientError(error.message || "Failed to load clients.");
    } finally {
      setLoadingClients(false);
    }
  }, []);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  return {
    clients,
    selectedClientId,
    setSelectedClientId,
    loadingClients,
    clientError,
    reloadClients: loadClients,
  };
}
